<template>
    <div class="logo">
        <a href="/" title="Sportopia">
            <img src="@/assets/white_logo.png" alt="">
        </a>
    </div>
</template>

<script>
export default {
    name: "HalfPageLogo"
}
</script>

<style scoped>
.logo{
    height: 100vh;
    width: 100%;
    display: grid;
    z-index: 2;
}
.logo img{
    place-self: center;
    max-width: 100%;
    width: 300px;
    z-index: 2;
}
a{
    place-self: center;
}
@media (max-width: 786px){
    .logo{
        height: 100px;
    }
    .logo img{
        width: 200px;
    }
}
</style>